import R from 'ramda';
import * as RuleUtils from '../screens/ScreenJourneys/utils/RuleUtils';
import QueryBuilder from '../screens/ScreenJourneys/QueryBuilder';
import AppsStore from '../stores/AppsStore_LEGACY';
import AccountStore from '../stores/AccountStore';

import {
  AMP_KEY,
  WEB_KEY
} from '../screens/ScreenJourneys/utils/journeyConstants';
import { LOADING_STATUS } from '../support/constants';

// Action Creators
import {
  APP_LOADED,
  FETCH_APP_STATS,
  FETCH_RULES,
  FETCH_VIEWS,
  SAVE_RULE,
  SAVE_VIEW,
  DELETE_RULE,
  DELETE_VIEW,
  UPDATE_SCRATCHPAD_RULE,
  UPDATE_SCRATCHPAD_VIEW,
  LOAD_AUDIENCE_RULE,
  SELECT_RULE_FOR_EDIT,
  SELECT_VIEW_FOR_EDIT,
  ADD_VIEW_FOR_RULE,
  REMOVE_VIEW_FOR_RULE,
  SET_VIEW_FREQUENCY,
  REORDER_TABLE,
  SAVE_REORDERED_RULES,
  PRIORITY_SORT,
  ALL_VIEWS_DICTIONARY,
  GET_VIEWS_AVAILABLE_FOR_PLATFORM,
  JOURNEY_DISMISS_SAVE_WARNING,
  SEARCH_GEO_REGIONS,
  LOAD_RULE_GEO_REGIONS
} from '../actions/JourneyActions';

function getCleanViewObject() {
  return {
    title: 'New View',
    template: '',
    type: 'BANNER',
    archived: false,
    data: '{}'
  };
}

function findViewById(views, id) {
  var view;
  if (!id) {
    view = getCleanViewObject();
  } else {
    view = R.find(view => view.id === id, views);
  }
  if (!view) {
    view = getCleanViewObject();
  }
  view.id = id;
  return view;
}

export const INIT_STATE = {
  version: 0,

  app_id: AppsStore.getAppId(),
  user_id: (AccountStore.getAccount() || {}).id,

  editing_view_id: '',
  editing_rule_id: '',

  scratchpad_view: null,
  scratchpad_rule: null,

  views: [],
  rules: false,
  warningModalDismiss: {},

  loadingStatus: LOADING_STATUS.INIT,
  ruleRegionMap: {},
  searchResultRegions: []
};

const ARCHIVED_PRIORITY = 999;

// Main reducer
// TODO: move to /dashboard/js/stores/JourneysStore.js
function JourneyReducer(previousState = INIT_STATE, action) {
  function findScratchpadOrRuleById(state, rule_id) {
    var rule;
    if (rule_id === 'new') {
      rule = state.scratchpad_rule || RuleUtils.getCleanRuleObject();
    } else if (!rule_id) {
      rule = RuleUtils.getCleanRuleObject();
    } else if (state.scratchpad_rule && state.scratchpad_rule.id === rule_id) {
      rule = state.scratchpad_rule;
    } else {
      rule = RuleUtils.findRuleById(state.rules, rule_id);
    }

    if (!rule) {
      rule = RuleUtils.getCleanRuleObject();
      rule.id = rule_id;
    }

    return rule;
  }

  var state = Object.assign({}, previousState);

  ++state.version;
  switch (action.type) {
    case APP_LOADED:
      state.app = state.app || {};
      if (state.app) {
        state.app = action.app;
      }
      break;
    case SET_VIEW_FREQUENCY:
      var { rule_id, view_index, freq } = action.data;

      (function(rule_id, index, freq) {
        var rule = findScratchpadOrRuleById(state, rule_id);
        if (rule) {
          freq = Math.max(Math.min(freq, 100), 0);
          rule.branch_views = rule.branch_views || [];
          var totals = R.reduce(
            (accum, view) => {
              if (accum.count === index) {
                view.percentage = freq;
              }

              accum.total += view.percentage;
              accum.count++;

              return accum;
            },
            {
              count: 0,
              total: 0
            },
            rule.branch_views
          );

          totals.overage = totals.total > 100 ? totals.total - 100 : 0;
          totals.count--;

          R.forEach(view => {
            var target = (totals.overage / totals.count) >>> 0; // eslint-disable-line no-bitwise
            if (totals.overage % totals.count) {
              target++;
            }
            if (target === 0) {
              return;
            }

            var viewTotal = view.percentage;
            if (viewTotal < target) {
              view.percentage = 0;
              totals.overage -= viewTotal;
            } else {
              view.percentage -= target;
              totals.overage -= target;
            }
            totals.count--;
          }, R.sortBy(R.prop('percentage'), R.remove(index, 1, rule.branch_views)));
        }
      })(rule_id, view_index, freq);
      break;
    case REMOVE_VIEW_FOR_RULE:
      var { rule_id, view_index } = action.data;
      (function(rule_id, index) {
        var rule = findScratchpadOrRuleById(state, rule_id);
        if (rule) {
          rule.branch_views = rule.branch_views || [];
          rule.branch_views.splice(index, 1);
        }
      })(rule_id, view_index);
      break;
    case ADD_VIEW_FOR_RULE:
      var { rule_id } = action.data;
      (function(rule_id) {
        var rule = findScratchpadOrRuleById(state, rule_id);
        if (rule) {
          var branch_view = RuleUtils.getCleanBranchView();
          branch_view.branch_view_id = undefined;
          rule.branch_views = rule.branch_views || [];
          rule.branch_views.push(branch_view);
        }
      })(rule_id);
      break;
    case 'SET_BRANCH_VIEW_FOR_RULE':
      (function(rule_id, view_id, index) {
        var rule = findScratchpadOrRuleById(state, rule_id);
        if (rule) {
          rule.branch_views = rule.branch_views || [];
          var branch_view = rule.branch_views[index] || {
            number_of_use: 100000,
            percentage: 42
          };
          branch_view.branch_view_id = view_id;
          rule.branch_views[index] = branch_view;
          // this should be in an action
          // RuleUtils.saveAudienceRule(store, rule_id, rule);
        }
      })(action.rule_id, action.view_id, action.view_index);
      break;
    case 'BRANCH_VIEW_LOADED':
      state.views = R.filter(
        view => view.id !== action.branch_view.id,
        state.views
      );
      state.views.push(R.clone(action.branch_view));
      state.views = R.sort((a, b) => {
        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
      }, state.views);
      if (state.editing_view_id) {
        state.scratchpad_view = R.clone(
          findViewById(state.views, state.editing_view_id)
        );
      }
      state = Object.assign({}, state, {
        all_views_dictionary: {
          ...state.all_views_dictionary,
          [action.branch_view.id]: action.branch_view
        }
      });
      break;
    case SELECT_VIEW_FOR_EDIT:
      var { view_id } = action.data;
      if (view_id != state.editing_view_id || !state.scratchpad_view) {
        state.editing_view_id = view_id;
        if (view_id) {
          state.scratchpad_view = R.clone(findViewById(state.views, view_id));
        } else {
          state.scratchpad_view = getCleanViewObject();
        }
      }
      break;
    case SELECT_RULE_FOR_EDIT:
      var { rule_id } = action.data;

      if (rule_id != state.editing_rule_id || !state.scratchpad_rule) {
        if (rule_id) {
          state.scratchpad_rule = R.clone(
            findScratchpadOrRuleById(state, rule_id)
          );
        } else {
          state.scratchpad_rule = RuleUtils.getCleanRuleObject();
        }
        state.editing_rule_id = state.scratchpad_rule.id;
      }
      break;
    case UPDATE_SCRATCHPAD_VIEW:
      var { data } = action;
      state.scratchpad_view = state.scratchpad_view || {};
      if (state.scratchpad_view) {
        state.scratchpad_view[data.key] = data.value;
      }
      break;
    case UPDATE_SCRATCHPAD_RULE:
      var { data } = action;
      state.scratchpad_rule = state.scratchpad_rule || {};
      if (state.scratchpad_rule) {
        state.scratchpad_rule[data.key] = data.value;
      }
      break;
    case FETCH_RULES.response:
      state.rules = R.map(r => {
        const rule = Object.assign({}, r);
        if (rule.status === 'ARCHIVED') {
          rule.priority = ARCHIVED_PRIORITY;
        }
        rule.builder = new QueryBuilder(rule.query);
        return rule;
      }, action.data);
      if (state.editing_rule_id) {
        state.scratchpad_rule =
          RuleUtils.findRuleById(state.rules, state.editing_rule_id) ||
          R.clone(findScratchpadOrRuleById(state, state.editing_rule_id));
      }
      break;
    case FETCH_VIEWS.response:
      state.views = action.data;
      if (state.editing_view_id) {
        state.scratchpad_view = findViewById(
          state.views,
          state.editing_view_id
        );
      }
      break;
    case FETCH_APP_STATS.response:
      state.app_stats = action.data || {};
      break;
    case SAVE_RULE.response:
      state.rules = R.filter(rule => rule.id !== action.data.id, state.rules);
      state.rules.push(
        R.assoc('builder', new QueryBuilder(action.data.query), action.data)
      );
      if (action.data) {
        state.scratchpad_rule = Object.assign(
          {},
          findScratchpadOrRuleById(state, action.data.id),
          action.data
        );
        state.editing_rule_id = action.data.id;
      } else if (state.editing_rule_id) {
        // TODO: We probably never hit this path.
        // Confirm and delete this `else if`
        state.scratchpad_rule = findScratchpadOrRuleById(
          state,
          state.editing_rule_id
        );
      }
      break;
    case SAVE_VIEW.request:
      state.loadingStatus = LOADING_STATUS.LOADING;
      break;
    case SAVE_VIEW.response:
      state.loadingStatus = LOADING_STATUS.LOADED;
      state.views = R.filter(view => view.id !== action.data.id, state.views);
      state.views.push(R.clone(action.data));
      state.views = R.sort((a, b) => {
        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0;
      }, state.views);
      if (state.editing_view_id) {
        state.scratchpad_view = R.clone(
          findViewById(state.views, state.editing_view_id)
        );
      }
      break;
    case DELETE_RULE.response:
      const ruleIndex = R.findIndex(R.propEq('id', action.data), state.rules);
      state.rules = [
        ...state.rules.slice(0, ruleIndex),
        ...state.rules.slice(ruleIndex + 1)
      ];
      break;
    case DELETE_VIEW.response:
      const viewIndex = R.findIndex(R.propEq('id', action.data), state.views);
      state.views = [
        ...state.views.slice(0, viewIndex),
        ...state.views.slice(viewIndex + 1)
      ];
      break;
    case 'JOURNEYS_GET_LANGUAGE_TABLE':
      state.language_tables = R.clone(action.data);
      break;
    case 'JOURNEYS_SAVE_LANGUAGE_TABLE':
      {
        state.language_tables = state.language_tables || [];

        const table = R.clone(action.data);
        let index = R.findIndex(t => {
          return t.id === table.id;
        }, state.language_tables);
        if (index < 0) {
          index = state.language_tables.length;
        }

        state.language_tables[index] = table;
      }
      break;
    case 'JOURNEYS_ADD_LANGUAGE_TABLE_ROW':
      {
        state.language_tables = state.language_tables || [];
        let index = R.findIndex(t => {
          return true;
        }, state.language_tables);
        let table = {};
        if (index > -1) {
          table = state.language_tables[index];
        } else {
          index = state.language_tables.length;
          table = {
            app_id: action.data.app_id,
            language: action.data.language,
            data: {}
          };
        }
        table.data[action.data.key] = action.data.value;
        state.language_tables[index] = table;
      }
      break;
    case SAVE_REORDERED_RULES.response:
      var clonedRules = Object.assign([], state.rules);

      R.forEach(rule => {
        if (rule.status === 'ARCHIVED') {
          rule.priority = ARCHIVED_PRIORITY;
        }
        rule.builder = new QueryBuilder(rule.query);

        const index = R.findIndex(R.propEq('id', rule.id), clonedRules);

        clonedRules[index] = rule;
      }, action.data);

      state.rules = clonedRules;
      break;
    case REORDER_TABLE:
      var { fromIndex, toIndex } = action.data;
      var clonedRules = Object.assign([], state.rules);

      clonedRules.splice(toIndex, 0, clonedRules.splice(fromIndex, 1)[0]);

      state.rules = clonedRules;
      break;
    case PRIORITY_SORT:
      var clonedRules = Object.assign([], state.rules);

      state.rules = R.sortBy(R.prop('priority'), clonedRules);
      break;
    case LOAD_AUDIENCE_RULE:
      state.rules = R.filter(
        rule => rule.id !== action.audience_rule.id,
        state.rules
      );
      state.rules.push(
        R.assoc(
          'builder',
          new QueryBuilder(action.audience_rule.query),
          action.audience_rule
        )
      );
      if (action.scratchpad_rule) {
        state.scratchpad_rule = R.clone(
          findScratchpadOrRuleById(state, action.audience_rule.id)
        );
        state.editing_rule_id = action.audience_rule.id;
      } else if (state.editing_rule_id) {
        state.scratchpad_rule = R.clone(
          findScratchpadOrRuleById(state, state.editing_rule_id)
        );
      }
      break;
    case ALL_VIEWS_DICTIONARY:
      state = Object.assign({}, state, {
        all_views_dictionary: action.payload.branch_views.reduce(
          (dict, view) => ({ ...dict, [view.id]: view }),
          {}
        )
      });
      break;
    case GET_VIEWS_AVAILABLE_FOR_PLATFORM:
      const { templateTypeOptions, platform } = action.payload;
      const reqPlatform = platform.indexOf(AMP_KEY) !== -1 ? AMP_KEY : WEB_KEY;
      state = Object.assign({}, state, {
        templateTypeOptions: [
          ...templateTypeOptions.filter(type => type.availableFor[reqPlatform])
        ]
      });
      break;
    case JOURNEY_DISMISS_SAVE_WARNING:
      state.warningModalDismiss = Object.assign({}, state.warningModalDismiss, {
        [action.data]: true
      });
      break;
    case SEARCH_GEO_REGIONS.response:
      const regions = action.data.map(region => {
        region.label = QueryBuilder.getRegionLabel(region);
        region.value = QueryBuilder.getRegionKey(region);
        // Add any new entries to the internal lookup map
        state.ruleRegionMap[region.value] = region;
        return region;
      });
      state.searchResultRegions = regions;
      break;
    case LOAD_RULE_GEO_REGIONS.response:
      const regionMap = action.data.reduce((acc, region) => {
        var key = region ? QueryBuilder.getRegionKey(region) : null;
        if (key) {
          acc[key] = region;
        }
        return acc;
      }, {});
      var rule = state.scratchpad_rule;
      rule.builder.setData(
        Object.assign({}, rule.builder.getData(), { regions: action.data })
      );
      state.scratchpad_rule = rule;
      state.ruleRegionMap = regionMap;
      state.loadingRegions = false;
      break;
  }

  return state;
}

export default JourneyReducer;
